module.exports = __webpack_public_path__ + "static/education-c1426d044acc00bd4fa73e7f7c8e1735.jpg";